import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch } from "app/hooks";
import MainNavigation from "components/MainNavigation/MainNavigation";
import LanguageSwitcher from "components/LanguageSwitcher/LanguageSwitcher";
import PageLink from "components/PageLink/PageLink";
import userContext from "common/utils/userContext";
import { logOut } from "features/core/reducer";
import styles from "./DesktopHeader.module.scss";

interface Props {
  links: any[];
  appLinks: any;
  localePath: string;
  registration: {
    url: string;
    text: string;
  };
  translations: any;
  registerLoginSettings: any;
  showIncompleteDetailsAlert?: any;
  hasViewDocumentsPermission: boolean;
  onLogout?: () => void;
}

const DesktopHeader = ({ links, appLinks, localePath, registration, translations, registerLoginSettings, showIncompleteDetailsAlert,hasViewDocumentsPermission }: Props) => {
  const user = useContext(userContext);
  const dispatch = useAppDispatch();
  const SPA_PATH = 'portal';
  let myAccountLink: any;

  const onLogout = () => {
    dispatch(logOut());
  }

  {
    (links || []).map((link: any,index:number) => {
      if (((link.url || '').includes(SPA_PATH))) {
        if (link.pageTypeName == "ArticlePage") {
          myAccountLink = link;
        }
      }
    })
  };
  return (
    <div className={styles.header}>
      <div className={styles.wrapper}>
        <div className={styles.brand}>
          <a href={localePath}>
            <img src={process.env.PUBLIC_URL + '/hoist_logo_color.svg'} width={198} height={50} className={styles.logo} alt="Logo" />
          </a>
        </div>
        <div className={styles.content}>
          <MainNavigation links={links} showIncompleteDetailsAlert={showIncompleteDetailsAlert} />
          <LanguageSwitcher />
          <div className={styles.buttons}>
            {user ? (
              <>
              {!hasViewDocumentsPermission &&
              (
                <a href={myAccountLink?.url} className={styles.button}>{myAccountLink?.name}</a>
              )}
                <a href={appLinks?.LogoutPage?.Uri} className={styles.button}>{translations?.Logout}</a>
              </>
            ) : (
              <>
                {registerLoginSettings.registrationPage &&
                  (<PageLink url={registration?.url} text={registration?.text} className={styles.button} />)
                }
                {registerLoginSettings.loginPage &&
                  (<PageLink url={appLinks?.LoginNewPage?.Uri} text={translations?.Login} className={styles.button} />)
                }
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeader;
